module.exports = __webpack_public_path__ + "images/marker-start.png";